<template>
  <div>
    <loader-ring v-if="getTerminalLoader" class="loader-center"></loader-ring>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular fw-bold">Terminals</h1>
        </div>
        <div class="col-auto"></div>
      </div>

      <TerminalStats :obj="stat" v-if="!getTerminalLoader && stat !== null" />

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Terminals</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="col-md-12">
              <div class="card card--no-shadow card-profile">
                <div class="card-header">
                  <h3 class="font-weight-600 mb-0">Filter Terminal</h3>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="">Account Number</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="account_number"
                            placeholder="11111111111"
                            maxlength="11"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="">Name</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="name"
                            placeholder=""
                            maxlength="11"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="">Terminal ID</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="terminalID"
                            placeholder=""
                            maxlength="11"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <button
                          @click.prevent="getTerminals(1)"
                          class="button mt-2"
                          :disabled="reportsLoading"
                        >
                          <span class="custom-loader" v-if="reportsLoading">
                            <loader-icon
                              size="1.5x"
                              class="custom-class"
                            ></loader-icon>
                            <span style="font-weight: 600; text-transform: initial;"
                              >Fetching Loan Data...</span
                            >
                          </span>
                          <span v-else>
                            Filter
                          </span>
                        </button>
                        <button
                          @click.prevent="clearFilter()"
                          class="button  mt-2"
                          :disabled="reportsLoading"
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CDataTable
              :items="terminals"
              :fields="fields"
              sorter
            >
              <template #owner="{item}">
                <td>{{ item.user.first_name + " " + item.user.last_name }}</td>
              </template>
              <template #updated_at="{item}">
                <td class="table--action-mobile">
                  {{ item.updated_at | date }}
                </td>
              </template>
              <template #action="{item}">
                <td
                  class="table--action-mobile"
                  v-if="permissions.includes('view-terminal')"
                >
                  <router-link
                    class="button btn-primary"
                    :to="{
                      name: 'ViewTerminal',
                      params: { slug: item.terminalID }
                    }"
                  >
                    View
                  </router-link>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import TerminalStats from "../../components/TerminalStats.vue";

const fields = ["terminalID", 'name', "owner", "account_number", "balance", "terminal_status", "action"];
export default {
  name: "Terminals",
  components: {
    CDataTable,
    CPagination,
    TerminalStats
  },
  data() {
    return {
      currentDate: Date.now(),
      fields,
      small: true,
      roles: [],
      getRolesLoading: false,
      getTerminalLoader: false,
      isStaffModal: false,
      creatingStaffLoading: false,
      terminals: [],
      next_page: 1,
      current: 1,
      total: 1,
      error_status: false,
      stat: null,
      account_number: "",
      name: "",
      terminalID: "",
    };
  },
  computed: {
    formIsValid() {
      return (
        this.staff.first_name !== "" &&
        this.staff.last_name !== "" &&
        this.staff.email !== "" &&
        this.staff.phone_number !== "" &&
        this.staff.role !== ""
      );
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    showUpdateModal(item) {
      this.staff = Object.assign({}, item);
      this.showStaffModal();
      console.log(this.staff);
    },
    closeStaffModal() {
      this.isStaffModal = false;
      this.staff = {};
    },
    showStaffModal() {
      this.isStaffModal = true;
    },
    async getTerminals(page) {
      try {
        this.getTerminalLoader = true;
        const response = await ApiService.get(
          `terminal/all-terminals?page=${page}&account_number=${this.account_number}&name=${this.name}&terminalID=${this.terminalID}`
        );
        this.terminals = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.getTerminalLoader = false;
      } catch (error) {
        console.log(error);
        this.getTerminalLoader = false;
        console.log(error.response);
        this.error_status = true;
      }
    },
    clearFilter() {
      this.account_number = "";
      this.name = "";
      this.terminalID = "";
      this.getTerminals(1);
    },
    onPageChange() {
      if (this.current != this.next_page) {
        console.log(this.next_page);
        if (this.error_status == false) {
          this.getTerminals(this.next_page);
        }
      }
    },
    async terminalStats() {
      try {
        const res = await ApiService.get("terminal/stats");
        this.stat = res.data.data;
        console.log(res, "hello");
      } catch (error) {
        console.log(error.response);
      }
    }
  },
  mounted() {
    this.getTerminals(1);
    this.terminalStats();
  }
};
</script>

<style scoped></style>
